import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { HashRouter as Router } from 'react-router-dom';

// ✅ Store root per element (fix for SPA + multiple mounts)
const rootMap = new Map();

function renderComponent(element) {
  if (!element) return;

  // Prevent duplicate mounting
  if (!rootMap.has(element)) {
    const root = createRoot(element);

    root.render(
      <Router>
        <Provider store={store}>
          <App />
        </Provider>
      </Router>
    );

    rootMap.set(element, root);
  }
}

// ✅ Custom Element
class WebComponent extends HTMLElement {
  connectedCallback() {
    renderComponent(this);
  }

  disconnectedCallback() {
    // ❌ DO NOT unmount (Liferay SPA reuses DOM)
  }
}

const elementId = "forgot-your-password";

if (!customElements.get(elementId)) {
  customElements.define(elementId, WebComponent);
}

// ✅ Initial load
document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector("forgot-your-password");
  renderComponent(el);
});

// ✅ Liferay SPA navigation fix (IMPORTANT)
window.Liferay.on("endNavigate", () => {
  const el = document.querySelector("forgot-your-password");
  renderComponent(el);
});